import React, { useEffect, useState } from "react";
import Imagesection from "../../component/productdetail/Imagesection";
import About from "../../component/productdetail/About";
import Descrption from "../../component/productdetail/Descrption";
import Branchimage from "../../component/productdetail/Branchimage";
import RatingReview from "../../component/productdetail/RatingReview";
import Paddyimage from "../../component/productdetail/Paddyimage";
import categoryModel from "../../model/category.model";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import back from "../../Asset/product/back.png";
import Related from "../../component/related/Related";
import Card from "../../component/recentlypurchsed/comsponent/Card";
import cartModel from "../../model/cart.model";
import { toast } from "../../lib/helper";
import { FaShoppingCart } from "react-icons/fa";
import cart from "../../Asset/recent/cart.png";
import { BiSolidPurchaseTag } from "react-icons/bi";
import AOS from "aos";
import "aos/dist/aos.css";
import login from "../../Asset/toast/login.png";
import addcart from "../../Asset/toast/addcart.png"
import wrong from "../../Asset/toast/wrong.png"
import address from "../../Asset/toast/address.png";

const Productdetail = () => {
  const parms = useParams();
  const navigate = useNavigate();
  const [countcart, setCountcart] = useState(1);
  const [countpreorder, setCountpreoder] = useState(1);
  const [countsubscribe, setCountsubscribe] = useState(1);
  const [datalist, setDataList] = useState();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [viewcart, setViewCart] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const Detail = async () => {
    setLoading(true);
    categoryModel
      .ProductDetail(parms?.id)
      .then((responce) => {
        setDataList(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    Detail();
  }, [location]);

  console.log("product detail",datalist)
  const AddCart = async (carttype) => {
    const form = new FormData();
    let quantity = 0;

    // Determine quantity based on carttype
    if (carttype === "regular") {
      quantity = countcart;
    } else if (carttype === "pre_order") {
      quantity = countpreorder;
    } else if (carttype === "subscription") {
      quantity = countsubscribe;
    }

    // Check if quantity is greater than 0
    if (quantity <= 0) {
      toast("Please select quantity", wrong);
      return;
    }

    // Continue with adding to cart
    form.append("cart_type", carttype);
    form.append("quantity", quantity);
    form.append("product_id", parms.id);

    cartModel
      .Addcart(form)
      .then((responce) => {
        
        setViewCart(responce?.data?.result?.cart_type);
        if (responce?.data?.result?.cart_type == "regular") {
          navigate("/cart");
        }
        if (responce?.data?.result?.cart_type == "pre_order") {
          navigate("/preorder");
        }
        if (responce?.data?.result?.cart_type == "subscription") {
          navigate("/subscribe");
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast(
          error?.response?.data?.message === "You Are Not Authorized"
            ? "Please login first then place the order"
            : error?.response?.data?.message,
          login
        );
      });
  };
  

  useEffect(() => {
    AOS.init({
      once: true,
      offset: 0,
    });
  }, []);

  useEffect(() => {
    AOS.refreshHard(); 
  }, [parms?.id]);
  return (
    <>
      <div
        className="w-full pt-14 md:pt-32 pb-44"
        style={{ backgroundImage: `url(${back})` }}
      >
        {!loading ? (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:px-16 px-4">
              <Imagesection datalist={datalist} />
              <About
                datalist={datalist}
                countcart={countcart}
                setCountcart={setCountcart}
                countpreorder={countpreorder}
                setCountpreoder={setCountpreoder}
                countsubscribe={countsubscribe}
                setCountsubscribe={setCountsubscribe}
                viewcart={viewcart}
                setViewCart={setViewCart}
              />
            </div>
            <div className="sm:px-16 px-4 w-full">
              <Descrption datalist={datalist} />
            </div>
            <div className=" w-full my-2 md:my-14">
              <Branchimage />
            </div>
            <div className="w-full sm:px-16 px-4">
              <RatingReview datalist={datalist} />
            </div>
            <div>
              <Paddyimage />
            </div>
            <div>
              <Related />
            </div>
            <div className="w-full px-4 md:px-16">
              <div className="mt-5 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ">
                {datalist?.releted_products?.map((item, index) => {
                  return <Card item={item} index={index} />;
                })}
              </div>
            </div>
          </>
        ) : (
          <div className="w-full flex justify-center py-24">
            wait
            <span className="loading loading-ball loading-xs"></span>
            <span className="loading loading-ball loading-sm"></span>
            <span className="loading loading-ball loading-md"></span>
            <span className="loading loading-ball loading-lg"></span>
            <span className="loading loading-ball loading-xl"></span>
          </div>
        )}
      </div>

      <div className="fixed right-5 bottom-10 z-50 flex flex-col gap-4 items-end">
        {datalist?.is_cart && (
          <button
            className="bg-textColor hover:bg-gray-700 text-white px-6 py-3 rounded-3xl shadow-xl  w-60 flex items-center gap-2 transition-all duration-300  hover:w-[245px]"
            onClick={() => AddCart("regular")}
            data-aos="zoom-in-left"
            data-aos-easing="linear"
            data-aos-duration="800"
            data-aos-once="true"
          >
            <FaShoppingCart /> Add to cart
          </button>
        )}

        {datalist?.is_pre_order && (
          <button
            className="bg-textColor hover:bg-gray-700 text-white px-6 py-3 rounded-3xl shadow-xl  w-60 flex items-center gap-2 transition-all duration-300  hover:w-[245px]"
            onClick={() => AddCart("pre_order")}
            data-aos="zoom-in-left"
            data-aos-easing="linear"
            data-aos-duration="800"
            data-aos-once="true"
          >
            <div className="w-4 h-4">
              <img src={cart} alt="" className="w-full h-full" />
            </div>{" "}
            Add to Pre Order Cart
          </button>
        )}

        {datalist?.is_subscribed && (
          <button
            className="bg-textColor hover:bg-gray-700 text-white px-6 py-3 rounded-3xl shadow-xl  w-60 flex items-center  gap-2 transition-all duration-300 hover:w-[245px]"
            onClick={() => AddCart("subscription")}
            data-aos="zoom-in-left"
            data-aos-easing="linear"
            data-aos-duration="800"
            data-aos-once="true"
          >
            <BiSolidPurchaseTag /> Subscribe Now
          </button>
        )}
      </div>
    </>
  );
};

export default Productdetail;
